import { render, staticRenderFns } from "./ItemMotif.vue?vue&type=template&id=315e7487&"
import script from "./ItemMotif.vue?vue&type=script&lang=js&"
export * from "./ItemMotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports